/* NZ_TIGHT_CARDS_V1 — fuerza precio + add-to-cart juntos en cards */
(function () {
  function findPrice(root) {
    return root.querySelector('.card__information .price, .price');
  }

  function findAddBlock(root) {
    // preferimos mover el FORM real de /cart/add o el product-form
    const form = root.querySelector('.card__information form[action^="/cart/add"]');
    if (form) return form;

    const pf = root.querySelector('.card__information product-form');
    if (pf) return pf;

    // wrappers conocidos tuyos
    const wrap = root.querySelector('.card__information .nz-mini-add-wrap, .card__information .nz-card-add-wrap, .card__information .nz-card-quickadd-form');
    if (wrap) return wrap;

    // fallback: botón de quick-add
    const btn = root.querySelector('.card__information button[name="add"], .card__information .quick-add__submit, .card__information .nz-add-btn');
    return btn || null;
  }

  function applyToCard(card) {
    if (!card || card.dataset.nzTightDone === '1') return;

    const priceEl = findPrice(card);
    const addEl = findAddBlock(card);
    if (!priceEl || !addEl) {
      card.dataset.nzTightDone = '1';
      return;
    }

    // Si el addEl es un botón suelto, intentamos mover su contenedor form/product-form si existe
    let nodeToMove = addEl;
    if (addEl.tagName === 'BUTTON') {
      const f = addEl.closest('form[action^="/cart/add"]');
      if (f) nodeToMove = f;
      const pf = addEl.closest('product-form');
      if (pf) nodeToMove = pf;
    }

    // Reubicar: justo después del precio
    const info = priceEl.closest('.card__information') || card;
    if (nodeToMove && priceEl.parentNode) {
      // evita mover si ya está inmediatamente después
      const next = priceEl.nextElementSibling;
      if (next !== nodeToMove) {
        priceEl.insertAdjacentElement('afterend', nodeToMove);
      }
    }

    card.dataset.nzTightDone = '1';
  }

  function run() {
    document.querySelectorAll('.card-wrapper, .card').forEach(applyToCard);
  }

  // Inicial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  // Shopify section reloads
  document.addEventListener('shopify:section:load', function () {
    setTimeout(run, 50);
  });

  // Observa cambios (filters, infinite scroll, ajax)
  const obs = new MutationObserver(function () {
    // resetea marcado solo en nodos nuevos
    document.querySelectorAll('.card-wrapper[data-nz-tight-done="1"], .card[data-nz-tight-done="1"]').forEach(function (n) {
      // mantenemos el done, no hacemos nada
    });
    setTimeout(run, 30);
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

/* NEZEND_DYNAMIC_MEDIA_ROWS_V1_START */
/*
  Mobile collection/search:
  - calcula proporción real de la imagen principal
  - agrupa cards por fila REAL
  - usa en ambas cards la proporción de la imagen más alta
  - mínimo 100%
  - máximo 150%
  - mantiene object-fit:contain
  - no toca título, precio ni CTA
*/
(function () {
  'use strict';

  var MOBILE_MAX = 749;
  var MIN_RATIO = 100;
  var MAX_RATIO = 150;
  var raf = 0;

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function getItems(grid) {
    if (!grid) return [];

    return Array.from(grid.children).filter(function (item) {
      return !!item.querySelector(
        '.product-card-wrapper .card__inner.ratio'
      );
    });
  }

  function getMediaInfo(item) {
    var inner = item.querySelector(
      '.product-card-wrapper .card__inner.ratio'
    );

    var img = item.querySelector(
      '.product-card-wrapper .card__media .media > img:first-child'
    );

    if (!inner || !img) return null;

    var width =
      parseFloat(img.getAttribute('width')) ||
      img.naturalWidth ||
      0;

    var height =
      parseFloat(img.getAttribute('height')) ||
      img.naturalHeight ||
      0;

    if (!width || !height) {
      return {
        inner: inner,
        ratio: 125
      };
    }

    var ratio = (height / width) * 100;

    ratio = Math.max(
      MIN_RATIO,
      Math.min(MAX_RATIO, ratio)
    );

    return {
      inner: inner,
      ratio: ratio
    };
  }

  function clearDynamicRatio(grid) {
    getItems(grid).forEach(function (item) {
      var inner = item.querySelector(
        '.product-card-wrapper .card__inner.ratio'
      );

      if (inner) {
        inner.style.removeProperty('--nz-row-media-ratio');
      }
    });
  }

  function alignRows() {
    var grid = getGrid();

    if (!grid) return;

    if (window.innerWidth > MOBILE_MAX) {
      clearDynamicRatio(grid);
      return;
    }

    var items = getItems(grid);

    if (!items.length) return;

    /*
      Primero quitamos el cálculo anterior.
      Así medimos las filas desde una base limpia.
    */
    clearDynamicRatio(grid);

    var rows = [];

    items.forEach(function (item) {
      var top = Math.round(item.offsetTop);

      var row = rows.find(function (candidate) {
        return Math.abs(candidate.top - top) <= 2;
      });

      if (!row) {
        row = {
          top: top,
          items: []
        };

        rows.push(row);
      }

      row.items.push(item);
    });

    rows.forEach(function (row) {
      var media = row.items
        .map(getMediaInfo)
        .filter(Boolean);

      if (!media.length) return;

      /*
        La imagen más vertical de la fila manda.
        Las demás usan la misma altura de zona visual.
      */
      var rowRatio = Math.max.apply(
        null,
        media.map(function (entry) {
          return entry.ratio;
        })
      );

      rowRatio = Math.max(
        MIN_RATIO,
        Math.min(MAX_RATIO, rowRatio)
      );

      var value =
        (Math.round(rowRatio * 10) / 10) + '%';

      row.items.forEach(function (item) {
          var inner = item.querySelector(
            '.product-card-wrapper .card__inner.ratio'
          );

          if (!inner) return;

          inner.style.setProperty(
            '--nz-row-media-ratio',
            value
          );
        });
    });
  }

  function scheduleAlign() {
    cancelAnimationFrame(raf);

    raf = requestAnimationFrame(function () {
      requestAnimationFrame(alignRows);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleAlign,
      { once: true }
    );
  } else {
    scheduleAlign();
  }

  window.addEventListener(
    'resize',
    scheduleAlign,
    { passive: true }
  );

  document.addEventListener(
    'shopify:section:load',
    scheduleAlign
  );

  /*
    Cubre:
    - filtros AJAX
    - infinite collection
    - nuevas cards
  */
  var observer = new MutationObserver(function (mutations) {
    var changed = mutations.some(function (mutation) {
      return mutation.addedNodes &&
             mutation.addedNodes.length;
    });

    if (changed) {
      scheduleAlign();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
/* NEZEND_DYNAMIC_MEDIA_ROWS_V1_END */

